<div class="profile-info-account profile-info-clickable" (click)="_goToMyAccount()">
  <p class="profile-info-account__title">{{ 'HEADER.ACCOUNT' | translate }}</p>
  <div class="profile-info-account__tag">
    <ac-state-tag [type]="_adminStateTagSig().tag" small>
      {{ _adminStateTagSig().desc | translate }}
    </ac-state-tag>
  </div>
  <p class="profile-info-account__name">{{ user.fullName }}</p>
  <address class="profile-info-account__email">
    <a href="mailto:{{ user.email }}" target="_blank" rel="noreferrer noopener">{{ user.email }}</a>
  </address>
</div>
<div class="profile-info-separator">
  <div class="profile-info-separator__border"></div>
</div>
@if (_showActions()) {
  <div class="profile-info-actions">
    @if (_isAdminOrSuperUser() || _impersonationTokenSig()) {
      <p class="profile-info-actions__title">{{ 'HEADER.CONFIG' | translate }}</p>
      @if (_isAdminOrSuperUser()) {
        <div class="profile-info-actions__item profile-info-clickable" [routerLink]="_userManagementRoute">
          {{ 'ROUTES.USER_MANAGEMENT' | translate }}
        </div>
      }
      @if (_impersonationTokenSig()) {
        <div class="profile-info-actions__item profile-info-clickable" (click)="_exitImpersonation()">
          {{ 'HEADER.IMPERSONATE.EXIT' | translate }}
        </div>
      } @else if (_isSuperUserSig()) {
        <div class="profile-info-actions__item profile-info-clickable" (click)="_impersonate()">
          {{ 'HEADER.IMPERSONATE.START' | translate }}
        </div>
        <div
          class="profile-info-actions__item profile-info-clickable flex items-center"
          (click)="_updateAnnouncements($event, _updateAnnouncementLoadingSig())"
        >
          <span>{{ 'HEADER.ANNOUNCEMENTS.UPDATE' | translate }}</span>
          @if (_updateAnnouncementLoadingSig()) {
            <mat-spinner class="ml-2" mode="indeterminate" color="primary" diameter="20" />
          }
        </div>
      }
    }
    @if (_multiCountry()) {
      @switch (_country()) {
        @case ('ES') {
          <div class="profile-info-actions__item profile-info-clickable" (click)="_changeCountry('PT')">
            {{ 'HEADER.CHANGE_COUNTRY_PT' | translate }}
          </div>
        }
        @case ('PT') {
          <div class="profile-info-actions__item profile-info-clickable" (click)="_changeCountry('ES')">
            {{ 'HEADER.CHANGE_COUNTRY_ES' | translate }}
          </div>
        }
      }
    }
    @if (_showChangeBusiness()) {
      <div class="profile-info-actions__item profile-info-clickable" (click)="_changeBusiness()">
        {{ 'HEADER.CHANGE_BUSINESS' | translate }}
      </div>
    }
  </div>
}
@if (!sideNav && (_isAuthenticated$ | async)) {
  <div class="profile-info-logout">
    <div
      class="profile-info-logout__link profile-info-clickable"
      role="button"
      (click)="_logout()"
      (keydown.enter)="_logout()"
      (keydown.space)="_logout()"
    >
      {{ 'HEADER.LOG_OUT' | translate }}
      <ac-icon name="sign-out" size="small" />
    </div>
  </div>
}
